import * as React from "react";
import styles from "./MRadio.module.css";
import { IconCircleFilled } from '@tabler/icons-react';

export interface MRadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  size?: 'sm' | 'md' | 'custom-20'; // default is md
}

export const MRadio = React.forwardRef<HTMLInputElement, MRadioProps>(
  ({ checked, disabled, className, size = 'md', ...props }, ref) => {
    // Icon color is set via CSS for checked/checked+disabled
    const customClass = `${styles.mRadioCustom}${size === 'sm' ? ' ' + styles.sm : ''}${size === 'custom-20' ? ' ' + styles.custom20 : ''}`;
    const iconClass = `${styles.mRadio__icon}${size === 'sm' ? ' ' + styles.sm : ''}${size === 'custom-20' ? ' ' + styles.custom20 : ''}`;
    const iconSize = size === 'sm' ? 15 : size === 'custom-20' ? 20 : 24;
    return (
      <label className={styles.mRadioLabel}>
        <input
          ref={ref}
          type="radio"
          checked={checked}
          disabled={disabled}
          className={styles.mRadioInput}
          {...props}
        />
        <span className={customClass}>
          {checked && (
            <span className={iconClass}>
              <IconCircleFilled size={iconSize} />
            </span>
          )}
        </span>
      </label>
    );
  }
);

export default MRadio;
